export default "__VITE_ASSET__49d9cbaf__"